// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import type {State as ReduxState} from '../../reducers';
import TripBoardButton from '@homeaway/react-trip-board-button';
import type {State as AbacusState} from '../../reducers/abacus';

type StateProps = {
    abacus: AbacusState,
    endDate?: string,
    siteName: string,
    startDate?: string
};

export type Props = {
    hit: {
        headline: string,
        listingId: string,
        position: string,
        rating: number,
        reviewCount: number,
        thumbnailUrl: string
    },
    isMapHit: boolean
} & StateProps;

const TripBoardComponent = ({
    abacus,
    endDate,
    hit: {headline, listingId, averageRating, reviewCount, thumbnailUrl1},
    isMapHit,
    siteName,
    startDate
}) => (
    <TripBoardButton
        abacus={abacus}
        endDate={endDate}
        headline={headline}
        listingId={listingId}
        position="left"
        rating={averageRating}
        reviewCount={reviewCount}
        siteName={siteName}
        startDate={startDate}
        thumbnailUrl={thumbnailUrl1}
        useNativeEventListener={isMapHit}
    />
);

const mapStateToProps = (state: ReduxState): StateProps => {
    const {abacus, searchParams, system} = state;
    const siteName = system.siteName;
    let {params} = searchParams;
    let startDate = params.arrival;
    let endDate = params.departure;
    return {
        abacus,
        endDate,
        siteName,
        startDate
    };
};

export default compose(connect(mapStateToProps))(TripBoardComponent);
